import PropTypes from 'prop-types'

const RemovalPending = ({ busy, children }) => (
  <fieldset
    disabled={busy}
    aria-busy={busy}
    style={{ display: 'contents' }}
    onClickCapture={(event) => {
      if (busy && event.currentTarget.contains(event.target)) {
        event.preventDefault()
        event.stopPropagation()
      }
    }}
  >
    {children}
  </fieldset>
)

RemovalPending.propTypes = {
  busy: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
}

export default RemovalPending
